import { ExternalLink } from "@/components/ExternalLink";
import i18n from "@/i18n";
import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";
import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";

export type C3StaticDatum = {
  id: number;
  name?: string;
  isin?: string;
  code?: string;
  currency?: string;
  asset_class_1?: string;
  asset_class_2?: string;
  has_transactions?: boolean;
  has_time_series?: boolean;
};

export const getC3StaticDataColumns = (
  t: (key: string, options?: Record<string, unknown>) => string,
): ColumnDef<C3StaticDatum>[] => [
  {
    accessorKey: "id",
    header: t("c3_static_data.columns.id", {
      ns: "tables",
      defaultValue: "ID",
    }),
  },
  {
    accessorKey: "name",
    header: t("c3_static_data.columns.name", {
      ns: "tables",
      defaultValue: "Nom",
    }),
  },
  {
    accessorKey: "isin",
    header: t("c3_static_data.columns.isin", {
      ns: "tables",
      defaultValue: "ISIN",
    }),
  },
  {
    accessorKey: "code",
    header: t("c3_static_data.columns.code", {
      ns: "tables",
      defaultValue: "Code",
    }),
  },
  {
    accessorKey: "currency",
    header: t("c3_static_data.columns.currency", {
      ns: "tables",
      defaultValue: "Devise",
    }),
  },
  {
    accessorKey: "asset_class_1",
    header: t("c3_static_data.columns.asset_class_1", {
      ns: "tables",
      defaultValue: "Classe d'actifs",
    }),
  },
  {
    accessorKey: "asset_class_2",
    header: t("c3_static_data.columns.asset_class_2", {
      ns: "tables",
      defaultValue: "Sous-classe d'actifs",
    }),
  },
  {
    id: "actions",
    cell: ({ row }) => {
      const hasTransactions = row.original.has_transactions;
      const hasTimeSeries = row.original.has_time_series;

      return (
        <div className="flex gap-11 justify-end">
          <div className="flex gap-3">
            <ExternalLink
              href={toWorkspacePath(
                `/admin/${Clients.C3}/${Tables.C3_TRANSACTIONS}`,
              )}
              queryParams={{
                c3_static_data_id_equal: row.getValue("id"),
              }}
              className={`text-xs ${
                !hasTransactions ? "invisible pointer-events-none" : ""
              }`}
              underline="hover"
            >
              {t("actions.transactions")}
            </ExternalLink>
            <ExternalLink
              href={toWorkspacePath(
                `/admin/${Clients.C3}/${Tables.C3_TIME_SERIES}`,
              )}
              queryParams={{
                c3_static_data_id_equal: row.getValue("id"),
              }}
              className={`text-xs ${
                !hasTimeSeries ? "invisible pointer-events-none" : ""
              }`}
              underline="hover"
            >
              {t("actions.valuations", { defaultValue: "Valorisations" })}
            </ExternalLink>
          </div>
          <Link
            href={`${window.location.pathname}/${row.getValue("id")}`}
            className="text-xs"
            underline="hover"
          >
            {i18n.t("actions.edit")}
          </Link>
        </div>
      );
    },
  },
];
